package ui.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color

@Composable
fun LoadingUI() {
    Box(Modifier.fillMaxSize()) {
        CircularProgressIndicator(Modifier.align(Alignment.Center))
    }
}

@Composable
fun LoadingOverlayUI() {
    Box(
        Modifier.fillMaxSize()
            .background(Color.Black.copy(alpha = 0.8F))
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null
            ) {}) {
        CircularProgressIndicator(Modifier.align(Alignment.Center))
    }
}